// Feature 1 — Acquisition tracking (utm + referrer + landing locale)
// Captures once per session, persisted to sessionStorage.
import { warn } from "@/lib/logger";

const STORAGE_KEY = "solarsim_attribution";

const parseUtm = (search) => {
  const params = new URLSearchParams(search || "");
  return {
    utm_source: params.get("utm_source") || null,
    utm_medium: params.get("utm_medium") || null,
    utm_campaign: params.get("utm_campaign") || null,
    utm_content: params.get("utm_content") || null,
  };
};

/**
 * Captures attribution on first hit. Idempotent — a subsequent call
 * with an already-populated sessionStorage will NOT overwrite the
 * original first-touch attribution.
 *
 * @param {string} landingLocale current i18n language (nl|fr|en)
 */
export function captureAttribution(landingLocale) {
  if (typeof window === "undefined") return null;
  try {
    const existing = sessionStorage.getItem(STORAGE_KEY);
    if (existing) return JSON.parse(existing);
    const utm = parseUtm(window.location.search);
    const ref = document.referrer || null;
    const attribution = {
      ...utm,
      referrer: ref && !ref.startsWith(window.location.origin) ? ref : null,
      landing_locale: (landingLocale || "").split("-")[0] || null,
      captured_at: new Date().toISOString(),
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
    return attribution;
  } catch (err) {
    warn("attribution.captureAttribution failed", err);
    return null;
  }
}

/** Returns the current attribution snapshot from sessionStorage, or null. */
export function getAttribution() {
  if (typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (err) {
    warn("attribution.getAttribution failed", err);
    return null;
  }
}
